import axios from "axios";
import store from "../store";
import { getCxid } from "./cxid";
import jsonpAdapter from "axios-jsonp";
import { Toast } from "vant";

const instance = axios.create({
  baseURL: "https://activity.bz.mgtv.com/",
  timeout: 10000,
});

instance.interceptors.request.use(
  function (config) {
    const { ticket, uuid } = store.state.userInfo;
    const { channelId } = getCxid();

    config.params = {
      ticket,
      uuid,
      channelId,
      ...config.params,
    };

    if (config.data) {
      config.data = {
        ticket,
        uuid,
        ...config.data,
      };
    }

    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response.data || {};
  },
  function (error) {
    Toast("网络异常");
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default {
  get(url, params, config) {
    return instance.get(url, { ...config, params });
  },
  post(url, data, config) {
    return instance.post(url, data, {
      ...config,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  put(url, data, config) {
    return instance.put(url, data, {
      ...config,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  delete(url, params, config) {
    return instance.delete(url, { ...config, params });
  },
  jsonp(url, params = {}) {
    return axios({
      url,
      adapter: jsonpAdapter,
      params,
    }).then((res) => res.data || {});
  },
};
